import { RetryPaymentProvider } from '@context/Payment/RetryPayment';

import RetryPaymentView from './RetryPaymentView';

const RetryPayment = () => {
  return (
    <RetryPaymentProvider>
      <RetryPaymentView />
    </RetryPaymentProvider>
  );
};

export default RetryPayment;
